export interface ExportFormat {
  format: string;
  label: string;
  description: string;
}

export function getExportFormats(mimeType: string): ExportFormat[] {
  if (mimeType === "application/vnd.google-apps.document") {
    return [
      { format: "pdf", label: "PDF", description: "Portable Document Format" },
      { format: "docx", label: "DOCX", description: "Microsoft Word Document" },
      { format: "rtf", label: "RTF", description: "Rich Text Format" },
      { format: "odt", label: "ODT", description: "OpenDocument Text" },
      { format: "html", label: "HTML", description: "Web Page" },
      { format: "txt", label: "TXT", description: "Plain Text" },
      { format: "epub", label: "EPUB", description: "E-book Format" },
    ];
  } else if (mimeType === "application/vnd.google-apps.spreadsheet") {
    return [
      { format: "pdf", label: "PDF", description: "Portable Document Format" },
      { format: "xlsx", label: "XLSX", description: "Microsoft Excel Spreadsheet" },
      { format: "ods", label: "ODS", description: "OpenDocument Spreadsheet" },
      { format: "csv", label: "CSV", description: "Comma Separated Values" },
      { format: "tsv", label: "TSV", description: "Tab Separated Values" },
    ];
  } else if (mimeType === "application/vnd.google-apps.presentation") {
    return [
      { format: "pdf", label: "PDF", description: "Portable Document Format" },
      { format: "pptx", label: "PPTX", description: "Microsoft PowerPoint Presentation" },
      { format: "odp", label: "ODP", description: "OpenDocument Presentation" },
      { format: "txt", label: "TXT", description: "Plain Text" },
    ];
  } else if (mimeType === "application/vnd.google-apps.drawing") {
    return [
      { format: "pdf", label: "PDF", description: "Portable Document Format" },
      { format: "png", label: "PNG", description: "Portable Network Graphics" },
      { format: "svg", label: "SVG", description: "Scalable Vector Graphics" },
      { format: "jpg", label: "JPG", description: "JPEG Image" },
    ];
  }

  return [];
}

export function getDefaultExportFormat(mimeType: string): string {
  const formats = getExportFormats(mimeType);
  return formats[0]?.format ?? "pdf";
}
